module.exports = __webpack_public_path__ + "img/about_2.46c674b1.jpg";